module.exports = {
  production: true,
  api: "https://api.app.osm.com.pt/v1/backoffice",
  amplify: {
    region: "eu-west-1",
    userPoolId: "eu-west-1_hSDa638yu",
    userPoolWebClientId: "6qkppshujrb07ju9f43e3v0saj",
  },
};
